import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Redirect } from 'react-router-dom';

import ChangePlan from '@app/views/ChangePlan';
import { UsagePage } from '@app/views/Usage';
import { hasUsageTab } from '@app/components/HeaderNavigation/utils';
import { selectUser } from '@app/redux';

import { NestedRoutes, RouteRenderProps } from '../utils';
import { PlanLink, ROUTES } from '../constants';

const noop = () => {
  //noop
};

export const planRoutes: RouteRenderProps[] = [
  {
    path: PlanLink.Plan,
    render: <UsagePage />,
    exact: true,
    fromParent: 0,
  },
  {
    path: PlanLink.ChoosePlanFilter,
    render: <ChangePlan navigateToOverview={noop} navigateToPreviousPage={noop} />,
    exact: true,
    fromParent: 0,
  },
];

const createPlanRoutes = (navigateToPreviousPage: () => void, navigateToOverview: () => void) => {
  return [
    ...planRoutes.filter((routeObj) => routeObj.path !== PlanLink.ChoosePlanFilter),
    {
      path: PlanLink.ChoosePlanFilter,
      render: <ChangePlan navigateToPreviousPage={navigateToPreviousPage} navigateToOverview={navigateToOverview} />,
      exact: true,
      fromParent: 0,
    },
  ];
};

export const PlanSwitch = (): JSX.Element => {
  const history = useHistory();

  const navigateToPreviousPage = () => {
    history.goBack();
  };

  const navigateToOverview = () => {
    history.replace('/');
  };

  const {
    user: { productKind },
  } = useSelector(selectUser);
  const canViewUsage = hasUsageTab(productKind);

  // Keep users without a usage tab (Fiber, Fixed Wireless) off the usage page; Change Plan stays reachable
  const routes = createPlanRoutes(navigateToPreviousPage, navigateToOverview).map((route) =>
    !canViewUsage && route.path === PlanLink.Plan ? { ...route, render: <Redirect to={ROUTES.HOME} /> } : route
  );

  return <NestedRoutes routes={routes} />;
};
